import { render, staticRenderFns } from "./latestNewsDetail.vue?vue&type=template&id=6dbae274&"
import script from "./latestNewsDetail.vue?vue&type=script&lang=js&"
export * from "./latestNewsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports